import { PaymentMethod } from "./PaymentMethod.ts";
import { PaymentMethodConfig } from "./PaymentMethodConfiguration.ts";
import { StripePaymentMethodConfig } from "./StripePaymentMethodConfiguration.ts";
import * as yup from "yup";
import { AnyObject, Maybe } from "yup";
import { HeyLightPaymentMethodConfig } from "./HeyLightPaymentMethodConfiguration.ts";

export const paymentMethodConfigRegistry: Record<
  PaymentMethod,
  PaymentMethodConfig<Maybe<AnyObject>>
> = {
  [PaymentMethod.Stripe]: StripePaymentMethodConfig,
  [PaymentMethod.HeyLight]: HeyLightPaymentMethodConfig,
};

export function getPaymentMethodConfig(
  method: PaymentMethod,
): PaymentMethodConfig<Maybe<AnyObject>> | undefined {
  return paymentMethodConfigRegistry[method];
}

export function getAvailablePaymentMethods(): PaymentMethod[] {
  return Object.keys(paymentMethodConfigRegistry) as PaymentMethod[];
}

export function buildPaymentMethodsValidationSchema(
  selectedMethods: PaymentMethod[],
): yup.ObjectSchema<Maybe<AnyObject>> {
  const schemaFields: Record<string, yup.Schema> = {};

  for (const method of selectedMethods) {
    const config = getPaymentMethodConfig(method);
    if (config) {
      schemaFields[config.configFieldName] = config.validationSchema;
    }
  }

  return yup.object(schemaFields);
}
